import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'ALIASED-antd';
import { PostcodeAutocomplete } from 'vl-common/src/components/PostcodeAutocomplete';

export interface PostcodeResponse {
  line1?: string;
  line2?: string;
  line3?: string;
  region?: string;
  town?: string;
  postcode?: string;
  country?: string;
  isAddressFound: boolean;
}

interface RandoxAutoCompleteSearchInputProps {
  onAddressFound?: (addressObj: PostcodeResponse) => void;
}

const RandoxAutoCompleteSearchInput = ({ onAddressFound }: RandoxAutoCompleteSearchInputProps) => {
  const { t } = useTranslation('common');
  return (
    <Form.Item label={t('Postcode')} name="postcode" required>
      <PostcodeAutocomplete
        onManualChange={() => {}}
        placeholder={t('Search address by postcode')}
        onSelect={(addressObj: any) => {
          if (!addressObj.isAddressFound) {
            return;
          }

          onAddressFound?.(addressObj);
        }}
        useAntd={true}
      />
    </Form.Item>
  );
};

export default RandoxAutoCompleteSearchInput;
